import { Button, RatingView, useAboveBreakpoint } from "imaginarity-react-ui";
import * as React from "react";
//import { useSelector } from "react-redux";
import { ApplicationState, useAppSelector } from "services/ApplicationState/ApplicationState";
import { gotoNamedRouteMethod, linkToRoute } from "services/Helpers/RoutingHelper";
//import { shallowCompare } from "services/Helpers";
//import { useImgI18N } from "services/ImgI18N";
import { PlayListNodeDownloadDto, PlaylistStateDownloadDto } from "collaboration-service";
import { getTranslated } from "services/Helpers/TranslationHelpers";
import History from 'services/History';
import { useImgI18N } from "services/ImgI18N";
import { isAdmin } from "services/StoreDependantHelpers";
import { PlaylistDetailSC as T } from 'views/Playlist/PlaylistDetailSC';



interface PlaylistDetailBannerProps {
    banner: string | undefined;
    stickyHeader: boolean;
    id: string;
    bannerTop: { playlist: string };
    data: PlayListNodeDownloadDto;
    playlistState?: PlaylistStateDownloadDto;
    tabsSelect: (index: number) => void;
}

const PlaylistDetailBanner = (p: PlaylistDetailBannerProps) => {
    const contentLanguage = useAppSelector((s: ApplicationState) => s.contentLanguage);
    const { banner, stickyHeader, id, bannerTop, data, playlistState, tabsSelect } = p;
    const { t } = useImgI18N("playlist");
    const isTablet = useAboveBreakpoint("largeMobile");
    const admin = isAdmin("WIKI");

    return (
        <T.BannerContainer imageUrl={banner ?? bannerTop.playlist} stickyHeader={stickyHeader} >
            <div style={{ position: "absolute", inset: 0, background: "linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.7) 70%)" }} />
            {data &&
                <>
                    <T.BannerTitle>
                        {getTranslated(data.headlines, contentLanguage)?.text}
                        {playlistState && playlistState.playlist.forbidRatings !== true && playlistState.playlist.rating > 0 && isTablet &&
                            <div style={{ position: "absolute", right: `calc(5.56% - 6px + ${admin ? 150 : 70}px)`, top: 10, padding: "0 15px 0 10px", height: 40, background: "rgba(255,255,255,0.4)", boxShadow: "0 6px 8px -6px #000" }}>
                                <div style={{ marginTop: -8 }} onClick={() => tabsSelect(0)}>
                                    <RatingView
                                        rating={playlistState?.playlist.rating ?? 0}
                                        maxStars={5}
                                        size={20}
                                        filledOut={true}
                                        filledColor='@accentRed'
                                    />
                                </div>
                            </div>
                        }
                        {isTablet &&
                            <div style={{
                                position: "absolute", right: "calc(5.56% - 6px)", top: 10,
                                width: "auto",
                                height: 40, background: "rgba(255, 255, 255, 0.0)", boxShadow: "0 6px 8px -6px #000"
                            }}>
                                {admin &&
                                    <Button
                                        kind='primary'
                                        tooltip={{ tooltipText: t("edit this playlist in new window"), position: "bottom" }}
                                        asHtmlLinkToRoute={linkToRoute(`playlist/editPlaylist/${id}`)}
                                        asHtmlLinkToRouteTarget="_blank"
                                        floated='right'
                                        icon="playlist edit"
                                    />
                                }
                                {admin &&
                                    <Button
                                        kind='primary'
                                        tooltip={{ tooltipText: t("assign playlist in new window"), position: "bottom" }}
                                        asHtmlLinkToRouteTarget="_blank"
                                        asHtmlLinkToRoute={linkToRoute(`playlist/assignPlaylist/${id}/self`)}
                                        floated='right'
                                        icon="user plus"
                                    />
                                }
                                <Button
                                    kind='cancelButton'
                                    tooltip={{ tooltipText: t("playlist overview"), position: "bottom" }}
                                    floated='right'
                                    icon="home"
                                    onClick={gotoNamedRouteMethod("playlist")}
                                />
                                <Button
                                    kind='cancelButton'
                                    tooltip={{ tooltipText: t("back"), position: "bottom" }}
                                    floated='right'
                                    icon="chevron left"
                                    onClick={() => History.goBack()}
                                />
                            </div>
                        }
                    </T.BannerTitle>
                </>
            }
        </T.BannerContainer>
    )
}

export default PlaylistDetailBanner;